import styled from 'styled-components/macro';
import { Row } from '@yme/atoms/grid';
import { HeadingLevel2, RegularTextLevel3 } from '@yme/tokens/typography';
export const RowStyled = styled(Row) `
  justify-content: center;
`;
export const HeadingLevel2Styled = styled(HeadingLevel2) `
  margin-bottom: 16px;
`;
export const RegularTextLevel3Styled = styled(RegularTextLevel3) `
  margin-bottom: 16px;
`;
